import { RETRIEVE_VILLES } from "./types";

export const retrieveVilles = (villes) => {
    return {
        type: RETRIEVE_VILLES,
        payload: villes,
    };
};